import React from "react";

const LabelComponent = ({
  labelText = "",
  size = "small",
  isMandatory = false,
  htmlFor = "",
  error,
  isFormDisabled = false,
  className = "",
}) => {
  return (
    <label
      htmlFor={htmlFor ? htmlFor : labelText}
      className={` ${className} ${isFormDisabled ? "text-6B6B6B" : "text-434852"}  block ${size === "small" ? "text-[0.9rem] py-1" : "text-[1rem] py-[2px]"} }`}
    >
      {labelText} {isMandatory && <span className="text-[#EF4444]">*</span>}
      {error && <span className="text-[#EF4444]"> {error}</span>}
    </label>
  );
};

export default LabelComponent;
